import { addActionBarItem, ActionBarContext } from '@vendure/admin-ui/core';
import { map } from 'rxjs/operators';

function findRefundButton(): HTMLButtonElement | null {
    const buttons = Array.from(
        document.querySelectorAll<HTMLButtonElement>('button.dropdown-item')
    );
    return (
        buttons.find(
            (b) => b.innerText.trim() === 'Reembolso & cancelamento do pedido'
        ) || null
    );
}

function disableOriginalRefundButton() {
    const observer = new MutationObserver(() => {
        const refundButton = findRefundButton();
        if (refundButton) {
            refundButton.disabled = true;
            refundButton.style.opacity = '0.5';
            refundButton.style.cursor = 'not-allowed';
            refundButton.title = 'Reembolso não permitido para boleto';
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Verificação imediata
    const refundButton = findRefundButton();
    if (refundButton) {
        refundButton.disabled = true;
        refundButton.style.opacity = '0.5';
        refundButton.style.cursor = 'not-allowed';
        refundButton.title = 'Reembolso não permitido para boleto';
    }
}

export default [
    addActionBarItem({
        id: 'refund-order-guard',
        label: '',
        locationId: 'order-detail',
        buttonState: (context: ActionBarContext) => {
            return context.entity$.pipe(
                map((order) => {
                    // Verifica se order existe
                    if (!order) {
                        return { disabled: false, visible: false };
                    }

                    // Verifica se é pagamento com boleto usando o custom field
                    const hasBoleto =
                        order.customFields?.pagarmePaymentType === 'boleto';

                    if (hasBoleto) {
                        // Desabilita o botão original
                        disableOriginalRefundButton();
                    }

                    return { disabled: false, visible: false };
                })
            );
        },
        onClick: () => {},
        requiresPermission: 'UpdateOrder',
    }),
];
